import { render, staticRenderFns } from "./GeneralTextWidget.vue?vue&type=template&id=076481ba&scoped=true&"
import script from "./GeneralTextWidget.vue?vue&type=script&lang=js&"
export * from "./GeneralTextWidget.vue?vue&type=script&lang=js&"
import style0 from "./GeneralTextWidget.vue?vue&type=style&index=0&id=076481ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076481ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
